import { ampli } from 'lib-shared-tracking';

import { PartnerTrackingEventsProps } from '../partners.types';

export const linearPartnerTrackingEvents = ({
  partnerEvents,
}: PartnerTrackingEventsProps): void => {
  partnerEvents.on('linear:create:new:issue:cancelled', (payload) =>
    ampli.partnerIntegrationsLinearCreateNewIssueCancelled(payload),
  );

  partnerEvents.on('linear:create:new:issue:clicked', (payload) =>
    ampli.partnerIntegrationsLinearCreateNewIssueClicked(payload),
  );

  partnerEvents.on('linear:create:new:issue:confirmed', (payload) =>
    ampli.partnerIntegrationsLinearCreateNewIssueConfirmed(payload),
  );

  partnerEvents.on('linear:link:issue:clicked', (payload) =>
    ampli.partnerIntegrationsLinearLinkIssueClicked(payload),
  );

  partnerEvents.on('linear:open:issue:clicked', (payload) =>
    ampli.partnerIntegrationsLinearOpenIssueClicked(payload),
  );

  partnerEvents.on('linear:open:linear:clicked', (payload) =>
    ampli.partnerIntegrationsLinearOpenLinearClicked(payload),
  );

  partnerEvents.on('linear:unlink:issue:clicked', (payload) =>
    ampli.partnerIntegrationsLinearUnlinkIssueClicked(payload),
  );
};
